import { render, staticRenderFns } from "./sr_cgm_report.vue?vue&type=template&id=6a251362&scoped=true"
import script from "./sr_cgm_report.vue?vue&type=script&lang=js"
export * from "./sr_cgm_report.vue?vue&type=script&lang=js"
import style0 from "./sr_cgm_report.vue?vue&type=style&index=0&id=6a251362&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a251362",
  null
  
)

export default component.exports